export enum MetalsProjectFileType {
    DXF = 'dxf',
    PDF = 'pdf',
    STL = 'stl',
    PNG = 'png',
    JPG = 'jpg',
    GLTF = 'gltf',
    /** Sheet metal bend config — the press brake station renders it in 3D. */
    BendConfig = 'bendconfig',

    // CAD files, not natively supported in threejs
    STEP = 'step',
    IGS = 'igs',

    DWG = 'dwg',
}


export const metalsProjectFileTypeToAssetUrlDict: Record<MetalsProjectFileType, string> = {
    [MetalsProjectFileType.DXF]: '/assets/icons/2d.svg',
    [MetalsProjectFileType.JPG]: '/assets/icons/image.svg',
    [MetalsProjectFileType.PNG]: '/assets/icons/image.svg',
    [MetalsProjectFileType.PDF]: '/assets/icons/pdf.svg',
    [MetalsProjectFileType.STL]: '/assets/icons/3d.svg',
    [MetalsProjectFileType.GLTF]: '/assets/icons/3d.svg',
    [MetalsProjectFileType.BendConfig]: '/assets/icons/3d.svg',
    [MetalsProjectFileType.STEP]: '/assets/icons/3d.svg',
    [MetalsProjectFileType.IGS]: '/assets/icons/3d.svg',
    [MetalsProjectFileType.DWG]: '/assets/icons/2d.svg',
}
export enum MetalsProjectFileCategory {
    TwoD = '2D',
    ThreeD = '3D',
    PDF = 'PDF',
    Image = 'Image'
}

export const metalsProjectFileTypeToCategory: Record<MetalsProjectFileType, MetalsProjectFileCategory> = {
    [MetalsProjectFileType.DXF]: MetalsProjectFileCategory.TwoD,
    [MetalsProjectFileType.DWG]: MetalsProjectFileCategory.TwoD,
    [MetalsProjectFileType.STL]: MetalsProjectFileCategory.ThreeD,
    [MetalsProjectFileType.GLTF]: MetalsProjectFileCategory.ThreeD,
    [MetalsProjectFileType.BendConfig]: MetalsProjectFileCategory.ThreeD,
    [MetalsProjectFileType.STEP]: MetalsProjectFileCategory.ThreeD,
    [MetalsProjectFileType.IGS]: MetalsProjectFileCategory.ThreeD,
    [MetalsProjectFileType.PDF]: MetalsProjectFileCategory.PDF,
    [MetalsProjectFileType.PNG]: MetalsProjectFileCategory.Image,
    [MetalsProjectFileType.JPG]: MetalsProjectFileCategory.Image,
}


export const metalsProjectFileTypeCategoryOrder = {
    [MetalsProjectFileCategory.TwoD]: 0,
    [MetalsProjectFileCategory.ThreeD]: 1,
    [MetalsProjectFileCategory.PDF]: 2,
    [MetalsProjectFileCategory.Image]: 3
};